export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "What does a BUS STOP sign mean?",
    options: [
      "Pickup and Drop-off point of a bus",
      "Bus lane",
      "No bus allowed",
    ],
    correctAnswer: "Pickup and Drop-off point of a bus",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
  {
    id: "question17",
    videoId: "video17",
    topic: "Driving",
    question: "A gas station sign means that:",
    options: [
      "A gas station is up ahead",
      "A bus station is up ahead",
      "None of the above",
    ],
    correctAnswer: "A gas station is up ahead",
    descriptionTitle: "GAS STATION Sign",
    description1:
      "A Gas Station traffic sign is not a standard traffic sign in most regions. Instead, information about the location of gas stations is typically provided through commercial signage, such as the signs posted by individual gas stations or businesses, or through GPS and mapping apps.",
  },
  {
    id: "question18",
    videoId: "video18",
    topic: "Driving",
    question: "When I see a pedestrian sign while driving:",
    options: [
      "Slow down, Yield to pedestrians",
      "Drive Faster to avoid congestion",
      "Stop, turn of engine and wait",
    ],
    correctAnswer: "Slow down, Yield to pedestrians",
    descriptionTitle: "PEDESTRIAN Sign",
    description1:
      "A Pedestrian Traffic Sign is a type of road sign that is designed to regulate the movement of pedestrians at or near roadways. These signs are used to enhance the safety of both pedestrians and drivers by providing instructions and warnings to pedestrians about how they should behave when crossing streets or walking near traffic.",
  },
];
